/**
 *
 * CustomFormField
 *
 */
import React from 'react';
import { CustomFormFieldProps } from 'app/components/CustomForm/CustomFormFields';
import { FormTextField } from 'app/components/Forms/FormTextField';

export function CustomFormShortText({
  formField,
  readonly,
  disabled,
  ...props
}: CustomFormFieldProps) {
  return (
    <FormTextField
      {...props}
      disabled={readonly || disabled}
      label={formField.Label}
      info={formField.Description ?? undefined}
      key={formField.Id}
      fullWidth
    />
  );
}
